/* global HTMLElement, customElements */

import { isAnchorLink } from '../utils/links.js'

class MenuElement extends HTMLElement {
  connectedCallback () {
    this.$toggle = this.querySelector('.js-menu__toggle')

    if (this.$toggle) {
      this.$toggle.addEventListener('click', () => this.toggle())
      this.$drawer = document.getElementById('menu__drawer')
      this.$drawer.addEventListener('drawer:hide', () => this.toggle(false))

      const handleAnchorLinkEvent = (e) => {
        let focusVisible

        if (e.type === 'keydown') {
          if (e.key !== 'Enter') {
            return
          }

          focusVisible = true
        }

        const $link = e.target.closest('a')

        if (!$link || !isAnchorLink($link.href)) {
          return
        }

        const $target = document.getElementById($link.hash.slice(1))

        if (!$target) {
          return
        }

        e.preventDefault()
        this.toggle(false)
        $target.scrollIntoView({ behavior: 'smooth', focusVisible })
        $target.focus({ preventScroll: true })
        window.history.pushState(null, '', $link.href)
      }

      this.$drawer.addEventListener('keydown', handleAnchorLinkEvent)
      this.$drawer.addEventListener('click', handleAnchorLinkEvent)
    }
  }

  toggle (force = null) {
    const oldState = this.$toggle.getAttribute('aria-expanded') === 'true'
    const newState = (force !== null)
      ? force
      : !oldState

    if (oldState === newState) {
      return
    }

    this.$toggle.setAttribute('aria-expanded', newState ? 'true' : 'false')
    this.$drawer.toggle(newState)
  }
}

customElements.define('x-menu', MenuElement)
